import logger from '@/utils/logger'

import { buildDate, buildHash } from '@/client/services/update/constants'

export default async function isUpdateAvailable(): Promise<boolean> {
  try {
    if (buildDate == null || buildHash == null) {
      throw new Error('Build date or hash is null when checking for update')
    }

    const apiResponse = await fetch('/api/version.json')

    const { hash, date } = await apiResponse.json()
    const newDate = new Date(date)
    const oldDate = new Date(buildDate)
    if (hash !== buildHash || newDate > oldDate) {
      return true
    }

    return false
  } catch (err) {
    logger.error('Error checking for application update', {
      err,
    })
    return false
  }
}
